import { render, staticRenderFns } from "./StaffIndividualYearlyAttendancePage.vue?vue&type=template&id=013a2a56&scoped=true&"
import script from "./StaffIndividualYearlyAttendancePage.vue?vue&type=script&lang=js&"
export * from "./StaffIndividualYearlyAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013a2a56",
  null
  
)

export default component.exports